import { config } from '../config.js';

/**
 * 生成画像の URL を組み立てる。
 *
 * 画像は非公開バケットにあり、API が Hub の認証を通して中継する。`<img>` は Cookie を
 * 自動で送るため、そのまま `src` に入れれば表示できる（署名付きURLの受け渡しは不要）。
 *
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business Points an image tag at the Hub's authenticated image relay, so generated material is never exposed through a public or guessable URL.
 * @graph-connects /coorde-images [calls] 生成画像の取得
 */

/**
 * ラン内の1コーデの画像 URL を返す。
 *
 * @graph-node {Function}
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business Builds the URL for one generated outfit image.
 * @graph-connects none
 */
export function buildCoordeImageUrl(runId: string, setId: string): string {
  // 末尾スラッシュの有無で分岐させず、必ず落としてから組み立てる
  const base = config.apiUrl.replace(/\/+$/u, '');
  return `${base}/coorde-images/${encodeURIComponent(runId)}/${encodeURIComponent(setId)}`;
}
